import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import pluralize from 'pluralize';
import I18n from 'app/common/i18n';
import {padZero} from 'app/utils';

import {history} from 'store';
import * as routePath from 'app/utils/routePath';

import Card from 'react-material-card';
import {Button} from 'dk-ui-lib';

const renderAcademyInfo =(entity, entityType) => {

// TODO: right now only one login for an acadmey 
// need to refactor academy.logins[0].name when multiple logins are created

	let shouldRenderLogins = _.isArray(entity.logins) && !_.isEmpty(entity.logins[0]);

	return (
		<div className='mt4'>
			<div>
				<div className='nunito-font font-size-14px color-757575'>
					{`${I18n.t('onboard.successfully_added')} ${entityType.toUpperCase()}`}
				</div>
				<div className='sub-heading mt1'>
					{entity.name.toUpperCase()}
				</div>
			</div>
			<hr className='my3 col-4 mx-auto'/>
			{shouldRenderLogins &&
				<div>
					<div className='sub-heading mt2'>
						{entity.logins[0].name}
					</div>
					<div className='mt1 semi-bold font-size-14px color-757575'>
						{I18n.t('onboard.login_created')}
					</div>
				</div>
			}
		</div>
	)
}

const handleClick = (resetEntity) => {
	history.push(routePath.dashboardRoute);
	resetEntity();
}

const OnboardSuccessView = ({entity, entityType, entityIcon, resetEntity}) => {

	return (
		<div level={1} className='container mx4 m3 px3 py4 center clearfix white-background'>
      {entityIcon}
      {renderAcademyInfo(entity, entityType)}
      <div className='col-4 mx-auto mt3'>
        <Button
            type='primary'
            buttonStyle={{padding: '0.6rem'}}
            labelStyle={{fontSize: '0.9rem'}}
            label={I18n.t('onboard.back_to_dashboard')}
            onClick={() => handleClick(resetEntity)} />
        </div>
     </div>
	);
}

export default OnboardSuccessView;


// WEBPACK FOOTER //
// ./src/views/onboard-success/index.js